export default __webpack_public_path__ + "static/media/favicon1.1b919cca.ico";